var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.064 21.51C17.8964 19.8535 19.1728 18.4611 20.7508 17.4881C22.3288 16.5151 24.1462 15.9999 26 16C28.695 16 30.959 16.991 32.69 18.605L29.823 21.473C28.786 20.482 27.468 19.977 26 19.977C23.395 19.977 21.19 21.737 20.405 24.1C20.205 24.7 20.091 25.34 20.091 26C20.091 26.66 20.205 27.3 20.405 27.9C21.191 30.264 23.395 32.023 26 32.023C27.345 32.023 28.49 31.668 29.386 31.068C29.9054 30.726 30.3501 30.2822 30.6932 29.7635C31.0363 29.2448 31.2706 28.6619 31.382 28.05H26V24.182H35.418C35.536 24.836 35.6 25.518 35.6 26.227C35.6 29.273 34.51 31.837 32.618 33.577C30.964 35.105 28.7 36 26 36C24.6866 36.0005 23.386 35.7422 22.1725 35.2399C20.9591 34.7375 19.8565 34.0009 18.9278 33.0722C17.9991 32.1436 17.2625 31.0409 16.7601 29.8275C16.2578 28.614 15.9995 27.3134 16 26C16 24.386 16.386 22.86 17.064 21.51Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1ee34418613b4d95cc662349df8a951a.svg";
export { ForwardRef as ReactComponent };